import type { GiftCode } from '@/models'

const SEED: [string, string, number, number, string][] = [
  ['GOLDRUSH26', '2,000 gold', 8_412, 10_000, '2026-09-01'],
  ['SEASON14', '500 gems', 10_000, 10_000, '2026-08-30'],
  ['WELCOMEBACK', 'Magical chest', 1_204, 50_000, '2026-12-31'],
  ['CLANWAR7', '1 Legendary card', 640, 2_500, '2026-09-15'],
  ['TOURNEYVIP', 'Season pass', 88, 500, '2026-08-20'],
  ['SUMMERFEST', '3,000 gold', 5_930, 25_000, '2026-09-30'],
  ['DEVTHANKS', '10,000 gems', 41, 100, '2026-10-10'],
]

const TODAY = new Date('2026-08-26')

export const GIFT_CODES: GiftCode[] = SEED.map(([code, reward, redeemed, limit, expires], i) => ({
  id: `gc_${i}`,
  code,
  reward,
  redeemed,
  limit,
  expires,
  status: redeemed >= limit ? 'Exhausted' : new Date(expires) < TODAY ? 'Expired' : 'Active',
}))
